import React from "react";
import {Pagination} from "react-bootstrap";

function STCPaginationPrev(props){
    return(
        <Pagination.Prev
            style={props.style}
            className={props.className}
            onClick={props.onClick}
        >
            {props.children}
        </Pagination.Prev>
    )
}
export default STCPaginationPrev